import Vue from 'vue'
import VueNumericInput from 'vue-numeric-input' 

Vue.use(VueNumericInput)
